import React from "react";

import TableHeaderContainer from "../TableHeaderContainer";

import { TABLE_SUPER_ADMIN_CLINIC_USER_LIST } from "constants/dashboard";
import { SortConfig } from "types/common";

const TableHeader: React.FC<{
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
}> = ({ onClick, sortConfig }) => {
  return (
    <TableHeaderContainer
      headerList={TABLE_SUPER_ADMIN_CLINIC_USER_LIST}
      onClick={onClick}
      sortConfig={sortConfig}
    />
  );
};

export default TableHeader;
